import {ModalV3} from "../../../../helpers/modals/ClassBased/ModalV3";
import {getFilesDataFromMediaCollection} from "../../../../helpers/media-library/collections";
import Axios from "axios";
import {handleAjaxSuccess} from "../../../../helpers/swalHelper";
import handleAjaxError from "../../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../../helpers/loading";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Class based version of initial modalV2
 */
class ManageMediaModal extends ModalV3 {
	init() {
		// Init save button
		const confirmButton = this.modalContainer.querySelector('.store-photos-button');

		confirmButton.addEventListener('click', () => {
			// Get photos
			const photos = getFilesDataFromMediaCollection(this.modalContainer, 'photos');
			loading();

			Axios.post(confirmButton.dataset.route, {photos})
				.catch(handleAjaxError)
				.then(handleAjaxSuccess)
				.finally(stopLoading)
		})
	}
}

export {ManageMediaModal}
